var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{attrs:{"id":"profile-widget-card","noEditButton":"","padding":false}},[_c('a',{attrs:{"href":_vm.widget.link,"target":"_blank"}},[(_vm.widget.media && _vm.widget.media.length > 0)?_c('img',{attrs:{"src":_vm.widget.media[0].url,"alt":_vm.widget.title}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }